import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../../../lib/format';
import { formatMoney } from '../../../lib/money';
import { DocFrame, Row } from '../DocFrame';
import { PrintLines } from '../PrintLines';
import type { PrintDocProps } from '../print-types';
import { registerPrintDoc } from '../print-registry';
import type { CreditNotePrint } from '../types';

export function CreditNoteDoc({ data, size, onReady }: PrintDocProps<CreditNotePrint>): ReactNode {
  const { t } = useTranslation();
  return (
    <DocFrame title={t('print.title.creditNote')} meta={data.meta} hasBarcode={false} onReady={onReady}>
      <Row label={t('print.number')} value={data.creditNoteNo} />
      <Row label={t('print.dateTime')} value={formatDateTime(data.issuedAt)} />
      <section className="print-block">
        <div className="print-label">{t('print.customer')}</div>
        {data.customer === null ? (
          <div>{t('print.walkIn')}</div>
        ) : (
          <>
            <div>{data.customer.name}</div>
            {data.customer.phone === null ? null : <div className="print-small">{data.customer.phone}</div>}
          </>
        )}
      </section>
      <section className="print-block">
        <div>{t(data.kind === 'PARTIAL' ? 'print.creditsInvoice' : 'print.reverses', { invoiceNo: data.invoiceNo })}</div>
        <div>{data.reason}</div>
      </section>
      {data.lines.length === 0 ? null : <PrintLines lines={data.lines} size={size} />}
      <section className="print-block print-totals">
        <Row label={t('print.amount')} value={<strong>{formatMoney(data.amount)}</strong>} />
      </section>
      {data.issuedBy === null ? null : <div className="print-small">{t('print.issuedBy', { name: data.issuedBy })}</div>}
    </DocFrame>
  );
}

registerPrintDoc<CreditNotePrint>('credit-note', CreditNoteDoc);
